module.exports = "/assets/data/642e7a1ae622bded6e2188928c243af0-LL22.data.json";